<app-primary-nav></app-primary-nav>
<router-outlet></router-outlet>
